import { configureStore } from "@reduxjs/toolkit";

import authReducer from "../slice/authSlice";
import LoginMiddleware from "../middleware/LoginMiddleware";
import userReducer from "../slice/UserSlice";
import craftDesignReducer from "../slice/CraftDesignSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    users: userReducer,
    craftDesigns: craftDesignReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(LoginMiddleware),
});

export default store;

